export const filterModel = {
    typeObjects: [
        {
            id: 1,
            name: 'Офис'
        },
        {
            id: 2,
            name: 'Свободного назначения'
        },
        {
            id: 3,
            name: 'Торговая площадь'
        },
        {
            id: 4,
            name: 'Склад'
        },
        {
            id: 5,
            name: 'Производство'
        },
        {
            id: 6,
            name: 'Общепит'
        },
        {
            id: 7,
            name: 'Гостиница'
        },
        {
            id: 8,
            name: 'Автосервис'
        },
        {
            id: 9,
            name: 'Здание'
        },
    ], 
}